import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import Reveal from "../Reveal";
import { useT } from "../../i18n/I18nProvider";

export const MoreNotes = ({ entries }) => {
  const t = useT();

  return (
    <section className="border-t border-ink-200">
      <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-12 py-12 md:py-16">
        <Reveal>
          <div className="overline mb-6 md:mb-8">{t("journal.moreLabel")}</div>
        </Reveal>
        <ul className="divide-y divide-ink-200">
          {entries.map((e, i) => (
            <Reveal as="li" key={e.slug} delay={i * 60} className="group">
              <Link
                to={`/journal/${e.slug}`}
                className="flex items-start justify-between gap-6 py-6 md:py-8"
                data-testid={`article-more-${e.slug}`}
              >
                <div>
                  <div className="overline mb-2">{e.date}</div>
                  <h3 className="font-display text-xl sm:text-2xl md:text-3xl tracking-tightest group-hover:translate-x-1 transition-transform duration-500">
                    {e.title}
                  </h3>
                </div>
                <ArrowUpRight
                  className="mt-1 w-5 h-5 shrink-0 text-ink-300 group-hover:text-ink-900 group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-all"
                  strokeWidth={1.4}
                />
              </Link>
            </Reveal>
          ))}
        </ul>
      </div>
    </section>
  );
};
